export default {"src":"/_next/static/media/addresspoint.74c1496e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};